
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/e/[channel]",
      function () {
        return require("private-next-pages/_sites/[site]/e/[channel]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/e/[channel]"])
      });
    }
  